var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveMenuBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 52,
    viewBox: "0 0 130 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_167_671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7553 41.3906L18.9375 36.1188L18.9375 12.1029L45.7553 6.83107L125.496 6.83107L125.496 41.3906L45.7553 41.3906Z",
    fill: "#FFE9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3644 43.3792L45.558 43.4172L45.7553 43.4172L125.496 43.4172L127.523 43.4172L127.523 41.3906L127.523 6.83107L127.523 4.80445L125.496 4.80445L45.7553 4.80446L45.558 4.80446L45.3644 4.84251L18.5466 10.1143L16.9109 10.4359L16.9109 12.1029L16.9109 36.1188L16.9109 37.7858L18.5466 38.1074L45.3644 43.3792Z",
    stroke: "white",
    strokeWidth: 4.05323
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_167_671)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.0318,
    cy: 23.2885,
    rx: 6.58651,
    ry: 6.5865,
    transform: "rotate(-90 37.0318 23.2885)",
    fill: "#C3BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_167_671",
    x: 0.697468,
    y: 0.751215,
    width: 128.851,
    height: 50.7725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.1331,
    dy: 2.02662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_167_671"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_167_671",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_167_671",
    x: 30.4453,
    y: 16.7021,
    width: 13.1729,
    height: 17.2261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.05323
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_167_671"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMenuBackgroundMobile);
export default __webpack_public_path__ + "static/media/activeMenuBackgroundMobile.ea71ba5de0e3e9a304df3e17b637bbac.svg";
export { ForwardRef as ReactComponent };